module.exports = __webpack_public_path__ + "img/HomePage-foods.7bc6d43.webp";